<div fxLayout="row"
  fxLayoutAlign="center center"
  class="flex-container ngx-data-table__header"
  [ngClass]="{'ngx-data-table__small-header' : useSmallRowSize}">
  <div class="flex-item" [fxFlex]="getFlex()">
    @if (showCheckboxes && rows && rows.length > 0) {
      <mat-checkbox class="ngx-data-table__checkbox checkbox-header"
        data-testid="select-all-checkbox"
        [checked]="isCustomersSelectedOnPage()"
        [hidden]="isAllCustomersNonSpotlight"
        [disabled]="disableCheckbox"
        (change)="selectAllOnPageOnly($event)">
      </mat-checkbox>
    }
  </div>
  @for (col of columns; track (col.prop || col.id || col.title || 'col') + '|' + $index) {
    @if (!col.hide) {
      <button type="button" class="flex-item cfa-plain-button"
        [fxFlex]="getColSize(col)"
        (click)="changeSort(col)"
       >
      <span [ngClass]="{'ngx-data-table__header-title': !colIsNotSortable(col) && rows.length > 0,
                        'ngx-data-table__header-mobile-full': useFullMobileTable,
                        'ngx-data-table__center-header-title': col.centerContent}"
          fxLayout="row"
          fxLayoutAlign="start center">
          <span [attr.data-testid]="col.title + '-column'">{{getColTitle(col,isMobile)}}</span>
          @if (!colIsNotSortable(col) && getColState(col) !== 'none' && rows.length > 0) {
            <mat-icon [@arrowState]="getColState(col)"
              fxFlex="5"
              class="ngx-data-table__arrow">
              chevron_left
            </mat-icon>
          }
        </span>
      </button>
    }
  }
  <!-- Account for space created from the chevron in the data table body-->
  <div fxFlex="25px"></div>
</div>
@if ((selectedItems?.length !== allCustomerIds?.length) && showCheckboxes && canSelectAll &&
  isCustomersSelectedOnPage() && !isOnePage() && (uniqueRowsOnPage.length > 0) && !isAllCustomersNonSpotlight) {
  <div
    class="flex-container ngx-data-table__select-all-message"
    fxLayout="row"
    fxLayoutAlign="center center">
    <span>Selected only {{uniqueRowsOnPage.length}} Customers on this page.</span>
    <button type="button" class="ngx-data-table__select-all-message-clickable cfa-plain-button cfa-plain-button--inline" (click)="selectAllClicked(true)">
      Click here to select all {{allCustomerIds.length}} Customers in your Spotlight
    </button>
  </div>
}

